import { getAppConfig } from '../../../config';

/**
 * The dashboard's own sign-up page, for the person a platform admin added
 * silently. One link: they create their account with the added email and the
 * club is matched by email — no invitation or password link involved.
 * HashRouter, so the route lives after `#`.
 */
export function dashboardSignUpUrl(): string {
    return `${getAppConfig().dashboardUrl.replace(/\/+$/, '')}/#/auth/sign-up`;
}
